module.exports = __webpack_public_path__ + "img/20191107163327497.5e32ee43.jpg";